module.exports = __webpack_public_path__ + "img/title-earth.9c82b1d.png";